<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="dashboard-analytics">
    <div class="vx-row">
      <!-- CARD 1: CONGRATS -->
      <div class="vx-col w-full lg:w-1/2 mb-base">
        <vx-card color="bg-primary"></vx-card>
        <vx-card
            class="text-center greet-user"
            :card-background="'linear-gradient(120deg ,rgba(109,213,237,.8), rgba(33,147,176,0.5)), url(' + require('@/assets/images/pages/card-bg-image-demo-1.jpg') + ')'"
            >
            <feather-icon
              icon="FlagIcon"
              class="p-6 mb-8 inline-flex rounded-full text-white shadow"
              svgClasses="h-8 w-8"
            ></feather-icon>
            <h1 class="mb-6 text-white">欢迎使用Match赛事评委中心！</h1>
            <p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto text-white">
              上次登录时间： {{ lastLoginTime }}
            </p>
            <p class="text-white">POWER BY JIADA</p>
        </vx-card>
      </div>

      <div class="vx-col w-full lg:w-1/4 md:w-1/2 mb-base">
          <vx-card class="px-6">
              <vs-avatar v-if="!user.photoURL" class="mx-auto my-6 block" size="80px" :src="require('@/assets/images/profile/default-avatar.png')" />
              <vs-avatar v-else class="mx-auto my-6 block" size="80px" :src="user.photoURL"/>
              <div class="text-center">
                  <h4>{{ user.displayName }}</h4>
                  <p class="text-grey">{{ user.motto }}</p>
              </div>
              <div class="flex justify-between text-center">
                  <!-- <span>
                      <p class="text-xl font-semibold">101</p>
                      <small class="text-grey">赛程</small>
                  </span> -->
              
              </div>
          </vx-card>
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col w-full lg:w-1/2 mb-base">
        <vx-card title="评审动态">
          <ul class="activity-timeline" v-if="matchDynamic.length > 0">
            <li
              :class="{ 'mt-8': index }"
              v-for="(item, index) in matchDynamic"
              :key="item.id"
            >
              <div class="timeline-icon bg-primary">
                <feather-icon
                  icon="FlagIcon"
                  svgClasses="text-white stroke-current w-5 h-5"
                ></feather-icon>
              </div>
              <div class="flex items-center">
                <div class="leading-tight">
                  <p class="feed-author font-semibold">
                    {{ item.title }}
                  </p>
                </div>
              </div>
              <p class="mt-4">{{ item.content }}</p>
              <small class="mt-3 inline-block">{{
                item.create_time
              }}</small>
            </li>
          </ul>
          <p v-else>没有任何赛事动态</p>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>

import { getToken } from '@/utils/tools';
import { getDynamic } from '@/api/message';

export default {
  data() {
    return {
      user: {},
      matchDynamic: [],
    };
  },
  created() {
    this.user = JSON.parse(localStorage.getItem('judgeInfo'))
    this.getDynamicList()
  },
  computed: {
    lastLoginTime() {
      return this.user.lastLoginTime?this.user.lastLoginTime:this.user.registerTime
    }
  },
  components: {
  },
  methods: {
    getDynamicList() {
      let that = this
      getDynamic({
        access_token: getToken(),
        type: 1,
      }).then(res => {
        if (res.data.err_code === 0) {
          that.matchDynamic = res.data.list.filter(item => item.type == 1)
          that.behaviorDynamic = res.data.list.filter(item => item.type == 2)
        }
      })
    },
  }
};
</script>

<style lang="scss">
#dashboard-analytics {
  .greet-user {
    position: relative;
    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }
    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  @media (max-width: 576px) {
    .decore-left,
    .decore-right {
      width: 140px;
    }
  }
}
</style>
